import React from "react";
import { Row, Col } from "reactstrap";
import { InputColumn } from "src/components/Inputs";
import { SelectSand } from "src/components/Selects";
import { useData } from "src/components/Table";
import { Edit, Insert } from "./Form";
import { ListButtonRow, ButtonDelete } from "src/components/Buttons";
import { deleteSand } from "src/services/api/tools";

const Sands: React.FC<Props> = () => {
  const item = useData<SandValues>();

  const onDelete = () => {
    if (item.selected.item && item.selected.item.id !== undefined) {
      return deleteSand(item.selected.item.id)
        .then(({ data }) => {
          item.deleted.set(item.selected.item);

          return Promise.resolve(data);
        })
        .catch(({ data }) => {
          return Promise.reject(data);
        });
    }

    return Promise.reject();
  };

  return (
    <Row>
      <Col sm={4}>
        <InputColumn label="Material">
          <Row>
            <Col>
              <SelectSand
                onChange={value => {
                  item.selected.set(value);
                }}
                updatedItem={item.updated.item}
                deletedItem={item.deleted.item}
                newItem={item.created.item}
              />
            </Col>
          </Row>
        </InputColumn>
        <Row>
          <Col>
            <ListButtonRow
              buttonsLeft={
                <>
                  <Insert insertedItem={item.created.set} />
                  <Edit
                    item={item.selected.item!}
                    updatedItem={item.updated.set}
                  />
                </>
              }
              buttonsRight={
                <ButtonDelete
                  disabled={!item.selected.item}
                  onClick={onDelete}
                />
              }
              marginTop="mt-2"
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Sands;
